export default __webpack_public_path__ + "static/media/online.26ddfdd6.png";